import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState } from './store';
import { AnyAction } from 'redux';
import { ThunkDispatch } from '@reduxjs/toolkit';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type TypedDispatch<T> = ThunkDispatch<T, any, AnyAction>;
export const useAppDispatch = () => useDispatch<TypedDispatch<RootState>>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
